import React, { useMemo } from 'react';

import { GetDefaultVideo } from "../../helpers/ConfigApi";

import Grid from '@material-ui/core/Grid';

import VideoPlayer from '../video/VideoPlayerJS';

export default (props) => {
  const defaultVideo = useMemo(() => GetDefaultVideo(props.config), [props.config]);

  return (
    <div className="container-event">
      <Grid container direction="row" justify="center" spacing={3}>
        <Grid item lg={9} md={9} xs={12}>
          <VideoPlayer src={defaultVideo} userId='' />
        </Grid>
      </Grid>
    </div>
  );
}
